import { render, staticRenderFns } from "./VDataInicial.vue?vue&type=template&id=7bc13e89&"
import script from "./VDataInicial.vue?vue&type=script&lang=js&"
export * from "./VDataInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports